module.exports = __webpack_public_path__ + "static/media/Mapa-de-mapa-de-vida.bb9ef577.jpg";